const METHOD_GUIDANCE = {
  simple: {
    family: 'Basica',
    randomizationUnit: 'Participante',
    balanceUnit: 'Nenhum balanceamento forcado',
    whenUse: 'Quando simplicidade e imprevisibilidade individual sao prioridade.',
    avoid: 'Amostras pequenas em que o desequilibrio entre bracos seria problemático.'
  },
  blocked: {
    family: 'Blocos',
    randomizationUnit: 'Participante',
    balanceUnit: 'Bloco fixo',
    whenUse: 'Quando o estudo precisa manter equilibrio ao longo da inclusao.',
    avoid: 'Quando a equipe pode inferir alocacoes futuras pelo tamanho fixo do bloco.'
  },
  'random-block': {
    family: 'Blocos',
    randomizationUnit: 'Participante',
    balanceUnit: 'Bloco variavel',
    whenUse: 'Quando voce precisa de equilibrio por blocos com menor previsibilidade.',
    avoid: 'Amostras ou estratos muito pequenos para os tamanhos de bloco escolhidos.'
  },
  clustered: {
    family: 'Cluster',
    randomizationUnit: 'Cluster',
    balanceUnit: 'Quantidade de clusters',
    whenUse: 'Quando o grupo inteiro precisa receber um unico tratamento para evitar contaminacao.',
    avoid: 'Quando participantes do mesmo centro podem ou devem receber tratamentos diferentes.'
  },
  'stratified-blocked': {
    family: 'Estratificada',
    randomizationUnit: 'Participante',
    balanceUnit: 'Estrato + bloco fixo',
    whenUse: 'Quando subgrupos precisam ficar equilibrados por blocos completos.',
    avoid: 'Estratos cujo tamanho nao e divisivel pelo tamanho fixo do bloco.'
  },
  'stratified-random-block': {
    family: 'Estratificada',
    randomizationUnit: 'Participante',
    balanceUnit: 'Estrato + bloco variavel',
    whenUse: 'Quando subgrupos precisam de equilibrio com menor previsibilidade.',
    avoid: 'Estratos muito pequenos ou tamanhos de bloco incompatíveis.'
  },
  'cluster-stratum': {
    family: 'Estratificada por centro',
    randomizationUnit: 'Participante',
    balanceUnit: 'Centro/cluster como estrato',
    whenUse: 'Quando o centro deve organizar o balanceamento, mas nao define um tratamento unico.',
    avoid: 'Ensaios clusterizados puros, nos quais o cluster inteiro deve receber o mesmo tratamento.'
  },
  'cluster-stratified': {
    family: 'Cluster',
    randomizationUnit: 'Cluster',
    balanceUnit: 'Estrato de clusters',
    whenUse: 'Quando clusters inteiros devem ser sorteados dentro de regioes ou categorias.',
    avoid: 'Estratos com poucos clusters em relacao ao numero de bracos.'
  }
};

function getMethodGuidance(technique) {
  const guidance = METHOD_GUIDANCE[technique];

  if (!guidance) {
    throw new Error(`Unknown randomization technique: ${technique}`);
  }

  return guidance;
}

module.exports = {
  getMethodGuidance,
  METHOD_GUIDANCE
};
